import React from 'react';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {Input, Submit, FormLayout, Layout, Panel} from 'shared/components';
import PasswordResetState from './PasswordResetState';
import {withState, t} from 'shared/core';
import Logo from 'img/collage-logo--blue@2x.png';
import { LoginErrorMessage } from 'shared/components/login';

const PasswordReset = observer(({uiState}) => {
  const {user, errors} = uiState;

  return (
    <Layout>
      <div className='mt4 col-8 md-col-6 lg-col-6 max-width-3 mx-auto'>
        <Panel>
          <div className='center py2 mb3'>
            <img src={Logo} alt='Collage' height='26px'/>
          </div>
          <Panel.Header title={t('password_reset.Reset your password')} />
          <form>
            <LoginErrorMessage errorMessage={errors.base} />
            <FormLayout>
              <Input
                type='password'
                value={user.newPassword}
                onChange={e => user.merge({newPassword: e.target.value})}
                errorMessage={errors.password}
                placeholder='password_reset.Password'
              />
              <Input
                type='password'
                value={user.confirmPassword}
                onChange={e => user.merge({confirmPassword: e.target.value})}
                errorMessage={errors.passwordConfirmation}
                placeholder='password_reset.Confirm Password'
              />
              <Submit onClick={() => uiState.submit()}>
                <FormattedMessage id='password_reset.Reset password'/>
              </Submit>
            </FormLayout>
          </form>
        </Panel>
      </div>
    </Layout>
  );
});

export default withState(PasswordReset, PasswordResetState);
